import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/approval/setting/v1`;

export function getLeave() {
    return axios({
        method: "GET",
        url: `${url}/detail/leave`,
        headers: getHeaders(),
    })
}

export function getOvertime() {
    return axios({
        method: "GET",
        url: `${url}/detail/overtime`,
        headers: getHeaders(),
    })
}

export function updateApproveById(data) {
    return axios({
        method: 'PUT',
        url: `${url}/update`,
        headers: getHeaders(),
        data: data
    });
}
